import { useEffect, useState } from 'react';

// Hooks
import { useToastsContext } from '@/utils/hooks/context/toast/useToastsContext';
import useToastsNotifications from '@/utils/hooks/swr/notifications/useToastsNotifications';

// Components
import Toast from '@/components/base/Toast';
import useUser from '@/utils/hooks/swr/useUser';

const maxDisplayedToasts = 3;

function ToastsWrapper() {
    const { user } = useUser();
    const [isHover, setIsHover] = useState<boolean>(false);
    const { notificationsInfos, dispatchToasts } = useToastsContext();
    const { toastsNotifications, mutateToastsNotifications } = useToastsNotifications({
        refreshInterval: 30000
    });

    const notifications = notificationsInfos.notifications;
    const nbMessages = notifications.length;
    const firstToastIndexVisible =
        nbMessages > maxDisplayedToasts ? nbMessages - maxDisplayedToasts : 0;

    // Stringify array of notifications to avoid to trigger the useEffect all the time
    const stringifyToastsNotifications = JSON.stringify(toastsNotifications);

    useEffect(() => {
        if (toastsNotifications.length && user?.settings?.enable_notifications) {
            dispatchToasts({
                type: 'ADD_MULTIPLE_TOASTS',
                payload: toastsNotifications
            });

            // Clear notifications from swr request
            mutateToastsNotifications(
                (prevState) => ({
                    ...prevState,
                    data: {
                        ...prevState.data,
                        notifications: []
                    }
                }),
                false
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stringifyToastsNotifications]);

    useEffect(() => {
        if (!notifications.length && isHover) {
            setIsHover(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notifications]);

    if (!notifications.length) return;

    return (
        <div
            data-testid="toasts-wrapper"
            className="fixed bottom-17 right-17 z-100 w-screen max-w-[350px]"
            onMouseOverCapture={() => setIsHover(true)}
            onMouseOutCapture={() => setIsHover(false)}>
            {notifications.map((notification, index) => {
                return (
                    <Toast
                        notification={notification}
                        key={notification.id}
                        toastIndex={index}
                        isHover={isHover}
                        firstToastIndexVisible={firstToastIndexVisible}
                        nbMessages={nbMessages}
                    />
                );
            })}
        </div>
    );
}

export default ToastsWrapper;
